<!--时间，没有ID-->
<template>
  <el-time-select
    v-model="mytime"
    v-bind="$attrs"
    :name="'c' + formItemMeta.columnId"
    :clearable="clearable"
    :format="showFormat"
    @change="myChange"
  >
  </el-time-select>
</template>

<script lang="ts">
  import { ref, watch, defineComponent } from 'vue'
  // import { ElTimeSelect } from 'element-plus'
  // 引入组件需要的属性 引入表单子控件的管理类
  import { itemProps, itemController } from '../map'

/**
 * 日期管理类
 * * 功能：
 * ** 按照类型提交数据，不是date()
 * ** 监听属性，设置value
 * * 参数：
 * ** value： control类的value
 * ** mySubmit： control类的mySubmit，直接就提交了
 * ** controlType：属性里的控件类型
 * * 返回
 * ** 绑定控件的 mydate
 * ** change 事件的 myChange
 */
const timeManage = (value) => {
  // 日期控件用的v-model，便于做类型转换
  const mytime = ref('')

  if (value.value !== null) {
    mytime.value = value.value
  }

  // 监听属性，设置给 mydate
  watch(() => value.value, (v1, v2) => {
    // 
    mytime.value = v1
  })

  // 向父组件提交数据。
  const myChange = (_val) => {
    value.value = _val // 提交给父组件

    // console.log('时间的 select：', _val)
  }

  return {
    mytime,
    myChange
  }
}

export default defineComponent({
  name: 'el-from-item-time-select',
  inheritAttrs: false,
  components: {
    // ElTimeSelect
  },
  props: {
    ...itemProps, // 基础属性
    showFormat: { // 返回数据的格式化。date：日期类型
      type: String,
      default: 'HH:mm'
    },
    returnFormat: { // 返回数据的格式化。date：日期类型
      type: String,
      default: 'HH:mm'
    },
    modelValue: [String]
  },
  emits: ['update:modelValue'],
  setup (props, context) {
    const { value } = itemController(props, context.emit)

    const { mytime, myChange } = timeManage(value)

    return {
      mytime,
      myChange
    }
  }
})
</script>
